import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	if: {
		id: 'eoc.escalation-policies.common.rule.if.no-translate',
		defaultMessage: 'IF',
		description: 'Label of first rule condition',
	},
	then: {
		id: 'eoc.escalation-policies.common.rule.then.no-translate',
		defaultMessage: 'THEN',
		description: 'The indicator of what gonna happen after conditions end',
	},
	'if-not-acked': {
		id: 'eoc.escalation-policies.common.rule.if-not-acked.no-translate',
		defaultMessage: 'Alert is not acknowledged',
		description: 'The indicator of rule when if-not-acked option is selected',
	},
	'if-not-closed': {
		id: 'eoc.escalation-policies.common.rule.if-not-closed.no-translate',
		defaultMessage: 'Alert is not closed',
		description: 'The indicator of rule when if-not-closed option is selected',
	},
	edit: {
		id: 'eoc.escalation-policies.common.rule.edit.no-translate',
		defaultMessage: 'Edit Escalation Rule',
		description: 'The label of edit escalation icon button',
	},
	delete: {
		id: 'eoc.escalation-policies.common.rule.delete.no-translate',
		defaultMessage: 'Delete Escalation Rule',
		description: 'The label of delete escalation icon button',
	},
	branchVerbalForm: {
		id: 'eoc.escalation-policies.common.rule.branch-verbal-form.no-translate',
		defaultMessage: `<strong>
    {time, plural,
      =0 {immediately}
      other {{time} min}
    }
    </strong>
    {time, select,
      0 {}
      other {after creation, }
    }
    {type, select,
      user {notify}
      schedule {
        {notifyType, select,
          default {notify on call users in }
          next {notify next user (in rotation) for }
          previous {notify previous user (in rotation) for }
          other {}
        }
      }
      team {
        {notifyType, select,
          all {notify all members of }
          users {notify users of }
          admins {notify admins of }
          default {route to team }
          random {notify a random member of }
          other {}
        }
      }
      other {after creation, }
    }
    <responder></responder>
    `,
		description:
			'Full message of then statement. Example: 10 min after creation, notify previous user (in rotation) for <responder></responder>',
	},
});

export default messages;
